import { Routes } from '@angular/router';
import { EmployeeTableComponent } from './employee-table/employee-table.component';
import { SickLeaveFormComponent } from './sick-leave/sick-leave-form.component';
import { SickLeaveConfirmationComponent } from './sick-leave/sick-leave-confirmation.component';
import { SickLeaveOverviewComponent } from './sick-leave/sick-leave-overview.component';
import {datevGuard} from "./datev-guard.guard";
import { LogoutComponent } from './logout/logout.component';
import {LoginComponent} from "./login/login.component";
import {authGuard} from "./auth.guard";
import {HomeComponent} from "./home/home.component";

export const routes: Routes = [
  {path: "login", component: LoginComponent, canActivate: [authGuard]},
  { path: '', component: HomeComponent, canActivate: [authGuard] },
  { path: 'employees', component: EmployeeTableComponent, canActivate: [authGuard] },
  { path: 'sick-leave', component: SickLeaveFormComponent, canActivate: [authGuard] },
  { path: 'datev/callback', component: SickLeaveFormComponent, canActivate: [authGuard, datevGuard] },
  { path: 'sick-leave/confirmation', component: SickLeaveConfirmationComponent, canActivate:[authGuard] },
  { path: 'sick-leave/overview', component: SickLeaveOverviewComponent, canActivate:[authGuard] },
  { path: 'logout', component: LogoutComponent },
  { path: '**', redirectTo: 'login' }
];